import React, { useEffect, useState } from 'react'
import { Choose } from 'react-extras'

import { PictureOutlined } from '@ant-design/icons'
import { Icon, Modal, Typography, Select } from 'antd'

import { api, request } from '../../../util/handlerRequestUtil'
import { getMessage } from '../../../util/IntlMessages'
import './Gallery.css'

const { Option } = Select

const STATUS = {
  ALL: { value: 'ALL', description: getMessage('actions.list.status.all') },
  NAO_PLANEJADA: { value: 'NAO_PLANEJADA', description: getMessage('actions.list.status.pending') },
  PLANEJADA: { value: 'PLANEJADA', description: getMessage('actions.list.status.planned') },
  REALIZADA: { value: 'REALIZADA', description: getMessage('actions.list.status.finished') },
  ATRASADA: { value: 'ATRASADA', description: getMessage('actions.list.status.late') }
}

const Gallery = function ({ customer }) {
  const [collapsed, setCollapsed] = useState(false)
  const [images, setImages] = useState([])
  const [previewVisible, setPreviewVisible] = useState()
  const [preview, setPreview] = useState({})
  const [isImage, setIsimage] = useState(false)
  const [actionStatus, setActionStatus] = useState(STATUS.ALL.value)
  const [filteredImages, setFilteredImages] = useState([])

  useEffect(() => {
    if (customer.id) {
      retrieveActionImages(customer.id)
    }
  }, [])

  async function retrieveActionImages(id) {
    try {
      const response = await request(api.getActionImagesByCustomer(id))
      response.forEach((fieldName) => {
        for (const [key, value] of Object.entries(fieldName)) {
          if (key.includes('image')) {
            fieldName.image = JSON.parse(value)
          }
        }
      })

      setImages(response)
      setFilteredImages(response)
    } catch (error) {
      console.error(error)
    }
  }

  async function handlePreview(image) {
    setPreviewVisible(true)
    setIsimage(true)
    setPreview(image)
  }

  const handleFiltedImagesByAction = (status) => {
    setActionStatus(status)

    status === STATUS.ALL.value
      ? setFilteredImages(images.filter((image) => image))
      : setFilteredImages(images.filter((image) => image.status === status))
  }

  const toggleCollapsed = () => setCollapsed((val) => !val)

  return (
    <div>
      <div style={{ padding: '2%' }}>
        <div className="default-header-div">
          <div className="collapse-images">
            <Typography.Title className="default-header-title" level={3}>
              <Icon
                type={collapsed ? 'up' : 'down'}
                style={{ marginRight: 13, fontSize: 15 }}
                onClick={toggleCollapsed}
              />
              <PictureOutlined style={{ marginRight: 13 }} />
              {getMessage('actionGallery')}
            </Typography.Title>

            <div className="filter-images">
              <Typography style={{ fontWeight: 'bold' }}>{getMessage('actions')}</Typography>
              <Select
                value={actionStatus}
                style={{ width: 200, marginTop: 5 }}
                onChange={(status) => handleFiltedImagesByAction(status)}
              >
                {Object.values(STATUS).map(({ value, description }) => (
                  <Option key={value} value={value}>
                    {description}
                  </Option>
                ))}
              </Select>
            </div>
          </div>

          {collapsed ? (
            filteredImages.length === 0 ? (
              <div className="container-empty-images">
                <PictureOutlined style={{ fontSize: 50, color: '#8591A1' }} />
                <Typography className="default-header-title label-empty-images" level={3}>
                  {getMessage('actionEmptyImages')}
                </Typography>
              </div>
            ) : (
              <div className="main">
                <div className="image-container">
                  {Object.values(filteredImages).map((data, index) => {
                    return (
                      <img
                        className="image"
                        key={index}
                        src={data.image[0] ? data.image[0].file.fileUri : null}
                        alt={data.image[0] ? data.image[0].caption : null}
                        onClick={() => handlePreview(data.image[0] ? data.image[0].file.fileUri : null)}
                      />
                    )
                  })}
                </div>
              </div>
            )
          ) : null}

          <Modal centered visible={previewVisible} footer={null} onCancel={() => setPreviewVisible(!previewVisible)}>
            <Choose>
              <Choose.When condition={isImage}>
                <img style={{ width: '100%' }} src={preview} alt="preview" />
              </Choose.When>
            </Choose>
          </Modal>
        </div>
      </div>
    </div>
  )
}

export default Gallery
